import styled from "@emotion/styled";
import {
  breakpoints,
  content_nav_height,
  side_content_width,
  main_nav_height,
  spacing,
} from "../../styles/vars";
import { at } from "../../styles/utils";

export const LayoutWrapper = styled.div`
  width: 100%;
  &.timeline {
    display: grid;
    grid-template-rows: 100vh auto;
  }
  ${at(breakpoints.laptop)} {
    width: auto;
    &.timeline,
    &.map {
      display: grid;
      grid-template-rows: min-content;
      grid-template-columns: ${side_content_width.laptop} calc(
          100% - ${side_content_width.laptop}
        );
    }
    &.front {
      display: block;
    }
  }
  ${at(breakpoints.desktop)} {
    &.timeline,
    &.map {
      grid-template-columns: ${side_content_width.desktop} calc(
          100% - ${side_content_width.desktop}
        );
    }
  }
`;

export const MainWrapper = styled.main`
  .front &,
  .outro & {
    padding: ${main_nav_height.mobile} 0 ${main_nav_height.mobile};

    ${at(breakpoints.laptop)} {
      padding: ${main_nav_height.laptop} 0 ${main_nav_height.laptop};
    }

    ${at(breakpoints.desktop)} {
      padding: ${main_nav_height.desktop} 0 ${main_nav_height.desktop};
    }
  }

  .timeline & {
    padding: calc(${main_nav_height.mobile} + ${content_nav_height.mobile}) 0 0;
    ${at(breakpoints.laptop)} {
      height: 100vh;
      padding: ${main_nav_height.laptop} 0 0;
    }
    ${at(breakpoints.desktop)} {
      padding: ${main_nav_height.desktop} 0 0;
    }
  }

  .map & {
    height: 100%;
    padding: ${({ layer }) =>
      layer === "groundwater"
        ? `calc(
      ${main_nav_height.mobile} + ${content_nav_height.mobile} +
        ${spacing.mobile}
    )
    0 147px;`
        : `calc(
      ${main_nav_height.mobile} + ${content_nav_height.mobile} +
        ${spacing.mobile}
    )
    0 ${spacing.mobile};`};

    ${at(breakpoints.laptop)} {
      padding: 0;
    }
  }
  .timeline &,
  .map & {
    ${at(breakpoints.laptop)} {
      grid-column: 2 / 3;
    }
  }
`;

export const MobilNavWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  z-index: 10;
  ${at(breakpoints.laptop)} {
    display: none;
  }
`;

export const MobileContentWrapper = styled.div`
  .map & {
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 2;
    width: 100%;
  }
  .timeline & {
    grid-row: 2 / 3;
  }
  ${at(breakpoints.laptop)} {
    display: none;
  }
`;

export const DesktopSideWrapper = styled.div`
  display: none;
  ${at(breakpoints.laptop)} {
    position: fixed;
    width: ${side_content_width.laptop};
    top: 0;
    height: 100vh;
    overflow: scroll;
    display: block;
    background: rgba(0, 0, 0, 0.8);
    z-index: 10;
    .front &,
    .outro & {
      height: ${main_nav_height.laptop};
      width: 100%;
    }
  }
  ${at(breakpoints.desktop)} {
    overflow: scroll;
    width: ${side_content_width.desktop};
    .front &,
    .outro & {
      height: ${main_nav_height.desktop};
      width: ${side_content_width.desktop};
    }
  }
`;

export const MainWrapperInner = styled.div`
  .front &,
  .outro & {
    padding: 0 ${spacing.mobile};
    width: 100%;

    ${at(breakpoints.desktop)} {
      padding: 0 ${spacing.desktop};
    }
  }
  .timeline & {
    width: 100%;
    height: 100%;
    ${at(breakpoints.laptop)} {
    }
  }
  .map & {
    position: relative;
    width: ${({ layer }) => (layer === "groundwater" ? "100%" : "200%")};
    ${at(breakpoints.laptop)} {
      width: 100%;
      padding: 142.5925925926% 0 0;
    }
  }
`;
